export const HttpStatus = {
  NO_CONTENT: 204,
  NOT_AUTHORIZED: 401,
  INTERNAL_ERROR: 500
};
